import {useState, useEffect} from 'react';
import styles from "../../assets/stylesheets/sass/ResetPassword.module.scss";

import ResetPasswordForm from '../form_elements/ResetPasswordForm';
import Dropdownlist from "../customComponents/Dropdownlist";
import FormError from "../form_elements/FormError";

import logo from "../../assets/images/logo.svg";
import logo_white from "../../assets/images/logo_white.svg";
import { ReactSession }  from 'react-client-session';
import success_animation from "../../assets/animations/success.json";
import Lottie from 'react-lottie-player'
import Button from '../customComponents/Button';
import FormLoader from '../form_elements/FormLoader';

export default function ResetPassword({language}){
    const [content_state, setcontent_state] = useState({});
	useEffect(()=>{
		const fetchData = async () =>{
           const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
           let res = await data.json();
           setcontent_state(res);
        }
        fetchData();

        const queryParams = new URLSearchParams(window.location.search)
        const tmp_code = (queryParams.get("code"));
        setcode(tmp_code);
        const passwordCheckData = {
            "code": tmp_code
        }
        handlePasswordCheck(passwordCheckData)
	}, [])

    const [code, setcode] = useState();

    const handlePasswordCheck = (passwordCheckData) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"passwordCheck?code="+passwordCheckData.code, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(
            res => res.json()
        ).then(
            data => {
                if(data.errorcode === 0){
                    setwhite_overlayLR(false);
                    setwhite_overlayLR(true);
                    setshowResetPasswordForm(true)
                }
                else{
                    setwhite_overlayLR(false);
                    setwhite_overlayLR(true);
                    setshowError(true);
                }
            }
        )
            
    }

    const [showResetPasswordForm, setshowResetPasswordForm] = useState(false);
    const [showError, setshowError] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [white_overlay, setwhite_overlay] = useState(false);
	const [white_overlayLR, setwhite_overlayLR] = useState(false);

    const closeError = () =>{

        setwhite_overlay(true);
        setwhite_overlayLR(false);
        setTimeout(function(){
            setwhite_overlayLR(true);
            setwhite_overlay(false);
            const queryParams = new URLSearchParams(window.location.search)
            const tmp_code = (queryParams.get("code"));
            setcode(tmp_code);
            const passwordCheckData = {
                "code": tmp_code
            }
            handlePasswordCheck(passwordCheckData);
            setshowSuccess(false);
            setshowError(false);
        }, 300)  
	}

    const animateShowSuccess = (v) =>{
        setwhite_overlay(true);

        setTimeout(function(){
            setwhite_overlay(false);
            setwhite_overlayLR(false);
            setwhite_overlayLR(true);
            setshowResetPasswordForm(false); 
            setshowSuccess(v);
        }, 300)
    }

    const animateShowError = (v) =>{
        setwhite_overlay(true);

        setTimeout(function(){
            setwhite_overlay(false);
            setwhite_overlayLR(true);
            setshowError(v);
        }, 300)   
    }

    const [lang_updater, setlang_updater] = useState("");
	const handleChangeLanguage = (lang) =>{
		setlang_updater(lang);
		ReactSession.set("language", lang);
	}

    useEffect(()=>{
		setlang_updater(language);
		ReactSession.set("language", language);
	}, [language])

	return (
	    <>  
        <div className={styles.main_container} datatype={lang_updater}>
            <div>
                <div className={styles.logo_container}>
					<img className={styles.logo} src={logo} alt="logo"/>
					<img className={styles.logo_white} src={logo_white} alt="logo"/>
				</div>
                <div className={styles.login_form}>
                    <div className={styles.login_main}>
                        {showResetPasswordForm ?
                        <>
                            {white_overlay && <div className={styles.white_overlayRL}></div>}
				            {white_overlayLR && <div className={styles.white_overlayLR}></div>}
                            <ResetPasswordForm code={code} setshowError={(v)=>animateShowError(v)} setshowSuccess={(v)=>{animateShowSuccess(v)}}/>
                        </>
                        :
                        (showError ? 
                            <>
                            {white_overlay && <div className={styles.white_overlayRL}></div>}
				            {white_overlayLR && <div className={styles.white_overlayLR}></div>}
                            <FormError transition={true} titleVisible={true} tryAgain={()=>{closeError()}}/>
                            </>
                            : 
                        (showSuccess ? 
                            <>
                            {white_overlay && <div className={styles.white_overlayRL}></div>}
                            {white_overlayLR && <div className={styles.white_overlayLR}></div>}
                            <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                            <h1 style={{margin:"2rem 0 1rem 0"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.success_title ? content_state[ReactSession.get("language")].ResetPassword.success_title : "Password changed") : "Password changed") : "Password changed"}</h1>
                            <Button value={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.success_button ? content_state[ReactSession.get("language")].ResetPassword.success_button : "To login page") : "To login page") : "To login page"} onClick={()=>{window.location.assign('/'+process.env.REACT_APP_PREFIX)}}/>
                            <Lottie loop={false} animationData={success_animation} play style={{ width: 200, height: 200 }}/>
                            </div>
                            </>
                            :
                            <>
                            {white_overlay && <div className={styles.white_overlayRL}></div>}
                            {white_overlayLR && <div className={styles.white_overlayLR}></div>}
                            <div style={{display:"flex", justifyContent:"center"}}>
                                <FormLoader />
                            </div>  
                            </>                         
                        )                           
                        )
                        }
                    </div>
                </div>
                <div className={styles.language_ddl}>
					<Dropdownlist value={lang_updater} data={[
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch && content_state[ReactSession.get("language")].General.language_dutch) : "Dutch"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french && content_state[ReactSession.get("language")].General.language_french) : "French"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english && content_state[ReactSession.get("language")].General.language_english) : "English")
                    ]} menuPlacement="auto" isSearchable={false} defaultValue type="language" width="small" onChange={(v)=>handleChangeLanguage(v)}/>
				</div>
            </div>	
            <div style={{position:"relative"}} className={styles.right_container}>
                <div style={{marginTop:"-4rem", marginLeft:"4rem"}}>
                    <p style={{fontSize:"3.7rem"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.right_maintitle ? content_state[ReactSession.get("language")].ResetPassword.right_maintitle :  "Reset password") : ""}</p>
                    <p style={{fontSize:"1rem", marginTop:"1rem"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.right_subtitle ? content_state[ReactSession.get("language")].ResetPassword.right_subtitle :  "Choose a good and safe password") : ""}</p>
                </div>
            </div>
        </div>
	    </>  
  	);
}